import { Directive, ElementRef } from '@angular/core';
@Directive({
    selector: '[password]'
})
export class AppPasswordDirective {
    private _shown = false;
    private templateShow = '<figure class="icon-view"><img src="/assets/svg/icons/icon-view.svg" alt=""></figure>';
    private templateHide = '<figure class="icon-view"><img src="/assets/svg/icons/icon-not-view.svg" alt=""></figure>';
    constructor(private el: ElementRef) {
        this.setup();
    }
    toggle(span: HTMLElement) {
        this._shown = !this._shown;
        if (this._shown) {
            this.el.nativeElement.setAttribute('type', 'text');
            span.innerHTML = this.templateHide;
        } else {
            this.el.nativeElement.setAttribute('type', 'password');
            span.innerHTML = this.templateShow;
        }
    }
    setup() {
        const parent = this.el.nativeElement.parentNode;
        const span = document.createElement('span');
        span.innerHTML = this.templateShow;
        span.addEventListener('click', (event) => {
            this.toggle(span);
        });
        parent.appendChild(span);
    }
}